<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div *ngIf="form.contains('marche')" class="col-12 col-lg">
			<label for="marche" class="form-label theme-main-color fw-bold"
				>Marché</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="marche"
				name="marche"
				formControlName="marche"
				[ngClass]="{
					'is-invalid': marche.invalid,
					'is-valid': marche.dirty && marche.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('description')" class="col-12 col-lg">
			<label for="description" class="form-label theme-main-color fw-bold"
				>Description</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="description"
				name="description"
				formControlName="description"
				[ngClass]="{
					'is-invalid': description.invalid,
					'is-valid': description.dirty && description.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('lot')" class="col-12 col-lg">
			<label for="lot" class="form-label theme-main-color fw-bold"
				>Lot</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="lot"
				name="lot"
				formControlName="lot"
				[ngClass]="{
					'is-invalid': lot.invalid,
					'is-valid': lot.dirty && lot.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('descriptionLot')" class="col-12 col-lg">
			<label for="descriptionLot" class="form-label theme-main-color fw-bold"
				>Description du lot</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="descriptionLot"
				name="descriptionLot"
				formControlName="descriptionLot"
				[ngClass]="{
					'is-invalid': descriptionLot.invalid,
					'is-valid': descriptionLot.dirty && descriptionLot.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('commande')" class="col-12 col-lg">
			<label for="commande" class="form-label theme-main-color fw-bold"
				>Commande</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="commande"
				name="commande"
				formControlName="commande"
				[ngClass]="{
					'is-invalid': commande.invalid,
					'is-valid': commande.dirty && commande.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('responsable')" class="col-12 col-lg">
			<label for="responsable" class="form-label theme-main-color fw-bold"
				>Responsable</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="responsable"
				name="responsable"
				formControlName="responsable"
				[ngClass]="{
					'is-invalid': responsable.invalid,
					'is-valid': responsable.dirty && responsable.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('dateDebut')" class="col-12 col-lg">
			<label for="dateDebut" class="form-label theme-main-color fw-bold"
				>Date de début</label
			>
			<input
				autocomplete="off"
				type="text"
				bsDatepicker
				class="form-control"
				id="dateDebut"
				formControlName="dateDebut"
			/>
		</div>
		<div *ngIf="form.contains('dateFin')" class="col-12 col-lg">
			<label for="dateFin" class="form-label theme-main-color fw-bold"
				>Date de fin</label
			>
			<input
				autocomplete="off"
				type="text"
				bsDatepicker
				class="form-control"
				id="dateFin"
				formControlName="dateFin"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('adjudicateur')" class="col-12 col-lg">
			<label for="adjudicateur" class="form-label theme-main-color fw-bold"
				>Adjudicateur</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="adjudicateur"
				name="adjudicateur"
				formControlName="adjudicateur"
				[ngClass]="{
					'is-invalid': adjudicateur.invalid,
					'is-valid': adjudicateur.dirty && adjudicateur.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('titulaire')" class="col-12 col-lg">
			<label for="titulaire" class="form-label theme-main-color fw-bold"
				>Titulaire</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="titulaire"
				name="titulaire"
				formControlName="titulaire"
				[ngClass]="{
					'is-invalid': titulaire.invalid,
					'is-valid': titulaire.dirty && titulaire.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('adresseFacturation')" class="col-12 col-lg">
			<label for="adresseFacturation" class="form-label theme-main-color fw-bold"
				>Adresse de facturation</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="adresseFacturation"
				name="adresseFacturation"
				formControlName="adresseFacturation"
				[ngClass]="{
					'is-invalid': adresseFacturation.invalid,
					'is-valid': adresseFacturation.dirty && adresseFacturation.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="services" class="form-label fw-bold">Services</label>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="let service of listService | orderBy : 'name' : 'asc'"
				>
				<div *ngIf="service.id !== 0">
					<input
						type="checkbox"
						name="{{ service.id }}"
						class="form-check-input"
						[value]="service"
						[checked]="isServiceCheck(service)"
						[ngClass]="{
							'theme-main-color-check': isServiceCheck(service)
						}"
						(change)="updateSelectedService($event, service)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ service.name }} {{ service?.cotraitant ? '(cotraitant)' : ''}}
					</label>
				</div>
			</div>
			</div>
		</div>
	</div>

	<div class="alert alert-danger alert-dismissible fade show"
			profile="alert"
			*ngIf="showErrorMsgPourcentage"
	>
		le total doit être égal à 100%
	</div>


	<div formArrayName="services">
		<div *ngFor="let row of servicesBonCommande.controls; let pointIndex = index;" [formGroupName]="pointIndex">
			<div class="row my-4">
				<div class="col-12 col-lg-2">
					<label for="region" class="form-label theme-main-color fw-bold">{{listSelectedBonCommandeService[pointIndex]?.service.name}}
					</label>
					<input
						autocomplete="off"
						type="number"
						min="0" 
						max="100"
						placeholder="Pourcentage de charge"
						class="form-control"
						id="pourcentageCharge"
						name="pourcentageCharge"
						formControlName="pourcentageCharge"
					/>
				</div>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('region')" class="col">
			<label for="region" class="form-label theme-main-color fw-bold">Région
			</label>
			<select
				id="region"
				class="form-select"
				name="region"
				formControlName="region"
				aria-label="Sélectionner une region"
				>
				<option *ngFor="let region of listRegion" value="{{ region.id }}">
					{{ region.name }}
				</option>
			</select>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Prestations</span>
	</div>

	<div class="row my-5">
		<div class="d-flex justify-content-start">
			<button
				*ngIf="form.get('references')"
				class="btn theme-green-button"
				type="button"
				(click)="onAddPrestation()"
				>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Ajouter une prestation
			</button>
		</div>
	</div>

	<div formArrayName="references">
		<div *ngFor="let row of referencesPrestations.controls; let pointIndex = index;" [formGroupName]="pointIndex">
		<div class="row my-4">
			<div class="col-12 col-lg">
				<label for="reference" class="form-label theme-main-color fw-bold"
					>Référence</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="reference"
					formControlName="reference"
				/>
			</div>
			<div class="col-12 col-lg">
				<label for="description" class="form-label theme-main-color fw-bold"
					>Description</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="description"
					formControlName="description"
				/>
			</div>
		</div>
		<div class="row my-4">
			<div class="col-12 col-lg">
				<label for="cible" class="form-label fw-bold"
					>Cible</label
				>
				<select
					id="cible"
					class="form-select"
					formControlName="cible"
				>
					<option [value]="CibleEnum.EEPUB">En emploi public</option>
					<option [value]="CibleEnum.EEPRIV">En emploi privé</option>
					<option [value]="CibleEnum.EF">Vers l'emploi</option>
				</select>
			</div>
			<div class="col-12 col-lg">
				<label for="quantite" class="form-label fw-bold"
					>Quantité</label
				>
				<input
				required
				type="number"
				min="1"
				class="form-control"
				formControlName="quantite"
				/>
			</div>
		</div>
		<div class="row my-4">
			<div class="col-12 col-lg">
				<label for="prix" class="form-label fw-bold"
					>Prix</label
				>
				<input
				required
				type="number"
				min="1"
				class="form-control"
				formControlName="prix"
				/>
			</div>
			<div class="col-12 col-lg">
				<label for="unite" class="form-label theme-main-color fw-bold"
					>Unité</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					id="unite"
					formControlName="unite"
				/>
			</div>
		</div>
		<div class="">
			<a
				(click)="removePrestation(pointIndex)"
				class="btn theme-red-button px-4"
			>
			Supprimer la prestation
			</a>
		</div>
	</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="
					!form.valid ||
					isValidateButtonClicked.value
				"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
